import { render, staticRenderFns } from "./ProgramManagementMember.vue?vue&type=template&id=60daf7a0&"
import script from "./ProgramManagementMember.vue?vue&type=script&lang=js&"
export * from "./ProgramManagementMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports